import formatRelative from 'date-fns/formatRelative';
import React from 'react';

import Avatar from '@glass/web/components/base/Avatar';

const getUserCardHeaderProps = (user) => {
  if (!user) {
    return {};
  }
  let title;
  const { profile, email, createdAt } = user;
  const { displayName: name } = profile || {};
  let subheader = createdAt
    ? `Member since ${formatRelative(new Date(createdAt), new Date())}`
    : '';
  if (name) {
    if (createdAt) {
      if (email) {
        title = `${name} (${email})`;
      }
    } else {
      title = name;
      subheader = email;
    }
  } else {
    title = email;
  }

  return {
    title,
    subheader,
    avatar: title?.[0] ? <Avatar aria-label="Avatar">{title[0].toUpperCase()}</Avatar> : undefined,
  };
};

export default getUserCardHeaderProps;
